export default {
  methods: {
    onShowAnnotationMenu({ annotation, position, onDelete }) {
      this.$emit('show-delete-confirmation', { annotation, onDelete })
    },

    onAnnotationError(message) {
      this.$emit('show-error-alert', message)
    },

    requireAuthenticatedUser(loginModalRef, callback) {
      if (!this.subscription_id) {
        loginModalRef?.show()
        return false
      }
      if (callback) callback()
      return true
    }
  }
}
